import { Page } from '@/typings/page';
import useCurrentPage from '@/hooks/useCurrentPage';

import { About } from './About.types';

export function useAboutData(): Page<About>['templateFields'] {
  return useCurrentPage<Page<About>>().templateFields;
}
